<div class="policy-page">
  <div class="policy-container">
    <h1>🍪 COOKIES POLICY</h1>
    
    <p class="brand-name"><strong>Pixie Pets</strong></p>
    <p class="last-updated"><em>Last updated: 22.12.2025</em></p>

    <hr>

    <h2>1. What are cookies?</h2>
    <p>Cookies are small text files stored on your device when you visit a website.<br>
    They help websites function properly, improve user experience, and provide information about how the site is used.</p>

    <hr>

    <h2>2. How we use cookies</h2>
    <p>Pixie Pets uses cookies to:</p>
    <ul>
      <li>ensure the website works correctly</li>
      <li>remember your preferences</li>
      <li>understand how visitors use our website</li>
      <li>improve our services and user experience</li>
    </ul>
    <p>Some cookies are essential for the website to function properly.</p>

    <hr>

    <h2>3. Types of cookies we use</h2>

    <h3>Essential cookies</h3>
    <p>These cookies are required for the website to function and cannot be disabled.<br>
    They include cookies related to security, page navigation, and order processing.</p>

    <hr>

    <h3>Analytics cookies</h3>
    <p>These cookies help us understand how visitors interact with our website (for example, which pages are visited most often).<br>
    This data is used only to improve Pixie Pets.</p>

    <hr>

    <h3>Marketing cookies</h3>
    <p>Marketing cookies may be used to show relevant content or offers and to measure the effectiveness of campaigns.</p>
    <p>These cookies are used <strong>only with your consent</strong>, where required by law.</p>

    <hr>

    <h2>4. Third-party cookies</h2>
    <p>Some cookies may be placed by trusted third-party services we use (such as analytics or payment providers).</p>
    <p>These third parties may collect data in accordance with their own privacy policies.</p>

    <hr>

    <h2>5. Managing cookies</h2>
    <p>You can manage or disable cookies through your browser settings at any time.<br>
    Please note that disabling certain cookies may affect how the website functions.</p>
    <p>Where required, you will be asked to provide consent for non-essential cookies.</p>

    <hr>

    <h2>6. Policy updates</h2>
    <p>This Cookies Policy may be updated from time to time.<br>
    The current version will always be available on this page.</p>
  </div>
</div>
